var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneAnswer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.027 20.948c3.43 3.433 7.595 6.082 11.002 6.082 1.53 0 2.87-.534 3.953-1.722.627-.701 1.018-1.52 1.018-2.329 0-.594-.224-1.164-.782-1.568l-3.642-2.59c-.559-.38-1.022-.57-1.451-.57-.532 0-1.018.31-1.565.844l-.843.831a.638.638 0 0 1-.452.19c-.178 0-.353-.071-.474-.13-.733-.393-1.994-1.473-3.168-2.638-1.162-1.164-2.244-2.423-2.624-3.16-.057-.13-.129-.297-.129-.475 0-.154.046-.309.178-.44l.844-.867c.52-.546.843-1.021.843-1.568 0-.428-.205-.89-.597-1.45L10.586 5.79c-.414-.57-.995-.82-1.636-.82-.783 0-1.592.357-2.29 1.034C5.509 7.108 5 8.473 5 9.983c0 3.41 2.598 7.543 6.027 10.965z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneAnswer);
export default __webpack_public_path__ + "static/media/Phone_Answer.31f24702fe72e595976935cf1711473e.svg";
export { ForwardRef as ReactComponent };